import React, { useState, useRef, useEffect } from "react";
import { FaChevronDown, FaChevronUp, FaChevronRight } from "react-icons/fa";
import styles from "../../lib/Common/commonStyles";
import {
  saveOnDB,
  convertToGermanCurrencyWithoutSymbol,
} from "../../lib/Common/definedFunctions";
import { useTranslation } from "react-i18next";
import { TooltipMessage } from "./ToolTipmessage";

const OfferCard = ({
  values,
  setStep,
  visible = false,
  setHide,
  hide,
  data = {},
}) => {
  const { t } = useTranslation();
  const contentRef = useRef(null);
  const infoIconPath = require("../../assets/images/info_i.png");
  const [isExpanded, setIsExpanded] = useState(false);
  const [error, setError] = useState(false);
  const date = new Intl.DateTimeFormat("de-DE", {
    timeZone: "Europe/Berlin",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).format(new Date());
  const time = new Intl.DateTimeFormat("en-US", {
    timeZone: "Europe/Berlin",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  }).format(new Date());
  const createCustomer = async () => {
    try {
      saveOnDB(data, false);
      // if (response?.status === "success") {
      // localStorage.setItem("customer_id", response?.result?.id);
      setStep(2); // Move to the next step after successful creation
    } catch (error) {
      console.error("Error creating customer:", error);
    }
  };
  useEffect(() => {
    const el = contentRef.current;
    if (!el) return;

    if (isExpanded) {
      el.style.maxHeight = el.scrollHeight + "px";
      el.style.opacity = 1;
      el.style.visibility = "visible";
    } else {
      el.style.maxHeight = "0px";
      el.style.opacity = 0;
      el.style.visibility = "hidden";
    }
  }, [isExpanded]);
  return (
    <div className="offer-card-container mb-4 w-100 maxWidth800">
      <div
        className={`c px-3 px-md-4 pt-2 pt-md-5 backgroundColorGreen text-dark rounded-top mb-0 ${
          !isExpanded ? " rounded-top mb-0 energy-offer-card" : ""
        }`}
      >
        <div className="row g-3">
          <div className="col-md-6">
            <h3 className="fontSize24Bold m-0 lineHeight27 text-blue mb-4 text-wrap">
              {values?.display_tariff_name}
            </h3>
            <ul className="list-unstyled m-0 mb-1 mb-md-3">
              <li className="d-flex align-items-center mb-1 mb-md-2">
                <img
                  src={require("../../assets/images/star-wbg.png")}
                  height={25}
                  width={25}
                  alt="Green Energy"
                  className="me-2"
                />
                <span className="fontSize16Regular lineHeight24 text-blue">
                  <strong>100% </strong> {t("Green Energy")}
                </span>
              </li>
              {/* <li className="d-flex align-items-center mb-1 mb-md-2">
                <img
                  src={require("../../assets/images/star-wbg.png")}
                  height={25}
                  width={25}
                  alt="Price Guarantee"
                  className="me-2"
                />
                <span className="fontSize16Regular lineHeight24 text-blue">
                  <strong>12 {t("month")} </strong>
                  {t("price guarantee")}
                </span>
              </li> */}
              <li className="d-flex align-items-center mb-1 mb-md-2">
                <img
                  src={require("../../assets/images/star-wbg.png")}
                  height={25}
                  width={25}
                  alt="Contract"
                  className="me-2"
                />
                <span className="fontSize16Regular lineHeight24 text-blue">
                  <strong>30 {t("days")}</strong> {t("minimum contract")}
                </span>
              </li>
            </ul>
            <div className="d-flex flex-column align-items-start gap-2 gap-md-3 mt-2 minHeight140">
              {/* TODO: Please enable below code for Enter promo code section
              Commenting enter promo code option as of now */}
              {/* <div className="input-group maxWidth310">
                <input
                  type="text"
                  className="form-control p-2 custom-input fontSize16Medium lineHeight24 promo-input"
                  placeholder="Enter Promo Code"
                />
                <button
                  className="btn btn-primary d-flex align-items-center borderTransparent promo-button"
                  onClick={() => {
                    setError(true);
                    setTimeout(() => {
                      setError(false);
                    }, 10000);
                  }}
                >
                  <FaChevronRight size={20} />
                </button>
              </div> */}

              {error && (
                <p className="fontSize14Medium lineHeight24 text-red mt-1 mb-0 mt-n12px">
                  {t("Invalid promo code. Please try again.")}
                </p>
              )}
              <div className="mt-lg-auto w-100 mt-3">
                {visible && (
                  <button
                    className="w-100 p-2 maxWidth310 fontSize16Medium lineHeight24 text-blue backgroundColorPink border-0 borderRadius12 choose-offer marginBottom20px"
                    onClick={() => {
                      localStorage.setItem("tariff_name", values?.tariff_name);
                      createCustomer();
                    }}
                  >
                    {t("Choose this offer")}
                  </button>
                )}
              </div>
            </div>
          </div>

          {/* Right Column */}
          <div className="col-md-6 medium text-blue mb-3 d-flex flex-column">
            {/* Monthly Price Display */}
            <div className="d-flex flex-wrap justify-content-center justify-content-md-end text-md-end mb-2 mb-md-3">
              <span className="fontSize42Bold text-blue flex-shrink-1 lineHeight1_3 mt-n12 word-break-all">
                {values?.monthlyPrice}
              </span>
              <span className="fontSize42Regular lineHeight1_3 text-blue ms-1 flex-shrink-0 mt-n12">
                €/{t("month")}*
              </span>
            </div>

            <div className="d-flex justify-content-between mb-1 mb-md-3">
              <span className="fontSize16Regular lineHeight24 text-blue text-nowrap">
                €/{t("year")}:
              </span>

              <span className="fontSize16Bold lineHeight24 text-blue text-end w-100 word-break-all">
                {values?.yearlyPrice}*
              </span>
            </div>
            <div className="d-flex justify-content-between mb-1 mb-md-3">
              <span className="fontSize16Regular lineHeight24 text-blue">
                {t("Base price €/month:")}
              </span>
              <span className="fontSize16Bold lineHeight24 text-blue text-end">
                <>{values?.basePrice}*</>
              </span>
            </div>
            {[
              "greenman_slp_spot_business_generic_2",
              "greenman_slp_spot_household_generic",
              "greenman_rlm_spot_business_generic",
              "greenman_slp_spot_household_generic_2",
              "greenman_rlm_spot_business_generic_2",
            ].includes(values?.tariff_name) && (
              <div className="d-flex justify-content-between mb-1 mb-md-3">
                {[
                  "greenman_slp_spot_business_generic_2",
                  "greenman_slp_spot_household_generic",
                  "greenman_slp_spot_household_generic_2",
                  "greenman_rlm_spot_business_generic_2",
                ].includes(values?.tariff_name) ? (
                  <span className="fontSize16Regular lineHeight24 text-blue">
                    {t("Network charges")}
                  </span>
                ) : (
                  <span className="fontSize16Regular lineHeight24 text-blue">
                    {t("network_charges")}
                  </span>
                )}
                <span className="fontSize16Bold lineHeight24 text-blue text-end">
                  {["Greenman RLM Dynamisch", "Greenman RLM500"].includes(
                    values?.display_tariff_name,
                  )
                    ? t("Varied monthly")
                    : values?.networkCharges + `*`}
                </span>
              </div>
            )}
            {/* {[
              "greenman_slp_single_step_business_generic_2",
              "greenman_slp_single_step_household_generic",
            ].includes(values?.tariff_name) && ( */}
            <div className="d-flex justify-content-between mb-1 mb-md-3">
              <span className="fontSize16Regular lineHeight24 text-blue">
                {t("Energy price ct/kWh:")}
              </span>
              <span className="fontSize16Bold lineHeight24 text-blue text-end">
                {values?.averageEnergyPrice} ct/kWh*
              </span>
            </div>
            {/*  )} */}
            {values?.yearSavings && (
              <div className="d-flex justify-content-between mb-1 mb-md-3">
                <span className="fontSize16Regular lineHeight24 text-blue flex-shrink-0">
                  {t("€/year savings:")}
                </span>
                <span className="fontSize16Bold lineHeight24 text-blue text-end w-100 flex-shrink-1 word-break-all">
                  {values?.yearSavings}*
                </span>
              </div>
            )}
            <div className="d-flex justify-content-end mt-auto pt-3">
              <div
                className="d-flex align-items-center medium text-blue cursor-pointer"
                onClick={() => {
                  setIsExpanded(!isExpanded);
                  if (setHide) setHide(!hide);
                }}
              >
                {isExpanded ? (
                  <FaChevronUp className="me-2 mt-2" color="#421F66" />
                ) : (
                  <FaChevronDown className="me-2 mt-2" color="#421F66" />
                )}
                <span className="fontSize16Regular lineHeight24 text-blue text-decoration-underline">
                  {isExpanded ? <>{t("Close")}</> : <>{t("More details")}</>}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`expandable-content ${isExpanded ? "expanded" : ""}`}
        ref={contentRef}
      >
        <div className="expandable-inner">
          <div className="column g-4">
            <div className="col-lg-12">
              <h4 className="fontSize24Bold lineHeight24 text-blue mb-2 mb-md-3">
                {t("Energy price for electricity consumption")}
              </h4>
              <ul className="list-unstyled medium">
                <li className="d-flex justify-content-between mb-1 mb-md-2">
                  <span className="fontSize16Regular lineHeight24 text-blue text-end">
                    {[
                      "greenman_slp_single_step_business_generic_2",
                      "greenman_slp_single_step_household_generic",
                    ].includes(values?.tariff_name) ? (
                      <>{t("Electricity price")}</>
                    ) : (
                      <>{t("Exchange electricity price")}</>
                    )}
                  </span>
                  <span className="fontSize16Regular lineHeight24 text-blue text-end">
                    {values?.exchangeElectricityPrice} ct/kWh *
                  </span>
                </li>
                <li className="d-flex justify-content-between mb-1 mb-md-2">
                  <span className="fontSize16Regular lineHeight24 text-blue">
                    <span> + </span>{" "}
                    {![
                      "greenman_rlm_spot_business_generic",
                      "greenman_rlm_spot_business_generic_2",
                    ].includes(values?.tariff_name) ? (
                      <>{t("Surcharges, network charges & taxes")}</>
                    ) : (
                      <>{t("Surcharge taxes")}</>
                    )}
                  </span>
                  <span className="fontSize16Regular lineHeight24 text-blue text-end">
                    {values?.surchargesTaxes} ct/kWh*
                  </span>
                </li>
                {[
                  "greenman_slp_spot_business_generic_2",
                  "greenman_rlm_spot_business_generic",
                  "greenman_slp_spot_household_generic",
                  "greenman_slp_spot_household_generic_2",
                  "greenman_rlm_spot_business_generic_2",
                ].includes(values?.tariff_name) && (
                  <li className="d-flex justify-content-between mb-1 mb-md-2">
                    <span className="fontSize16Regular lineHeight24 text-blue">
                      <span> + </span>
                      {t("Energy Service Fee")}
                    </span>
                    <span className="fontSize16Regular lineHeight24 text-blue text-end">
                      {convertToGermanCurrencyWithoutSymbol(
                        values?.energyServiceFee,
                      )}{" "}
                      ct/kWh*
                    </span>
                  </li>
                )}
                <li className="d-flex justify-content-between py-1 py-md-2 mt-1 mt-md-2 border-summary">
                  <span className="fontSize16Bold lineHeight24 text-blue">
                    {t("Average labour price")}
                  </span>
                  <span className="fontSize16Bold lineHeight24 text-blue text-end">
                    {values?.averageEnergyPrice} ct/kWh *
                  </span>
                </li>
              </ul>
            </div>

            <div className="col-lg-12">
              <h4 className="fontSize24Bold lineHeight24 text-blue mb-2 mb-md-3">
                {t("Monthly fees")}
              </h4>
              <ul className="list-unstyled medium">
                <li className="d-flex justify-content-between mb-1 mb-md-2">
                  <span className="fontSize16Regular lineHeight24 text-blue">
                    {[
                      "greenman_slp_spot_business_generic_2",
                      "greenman_slp_spot_household_generic",
                      "greenman_slp_spot_household_generic_2",
                    ].includes(values?.tariff_name) ? (
                      <>{t("Network charges")}</>
                    ) : (
                      <>
                        {[
                          "greenman_rlm_spot_business_generic",
                          "greenman_rlm_spot_business_generic_2",
                        ].includes(values?.tariff_name) ? (
                          <>{t("network_charges")}</>
                        ) : (
                          <>{t("base_price")}</>
                        )}
                      </>
                    )}
                  </span>
                  <span className="fontSize16Regular lineHeight24 text-blue text-end">
                    {["Greenman RLM Dynamisch", "Greenman RLM500"].includes(
                      values?.display_tariff_name,
                    )
                      ? t("Varied monthly")
                      : values?.networkCharges + ` €/${t("month")}*`}
                  </span>
                </li>
                {values?.GMEFee && (
                  <li className="d-flex justify-content-between mb-1 mb-md-2">
                    <span className="fontSize16Regular lineHeight24 text-blue">
                      {t("GME Fee")}
                    </span>
                    <span className="fontSize16Regular lineHeight24 text-blue text-end">
                      {values?.GMEFee} €/{t("month")}*
                    </span>
                  </li>
                )}
                <li className="d-flex justify-content-between py-1 py-md-2 mt-2 mt-md-2 border-summary">
                  <span className="fontSize16Bold lineHeight24 text-blue">
                    {t("Total monthly fees")}
                  </span>
                  <span className="fontSize16Bold lineHeight24 text-blue text-end">
                    {values?.totalMonthlyFees} €*
                    {values?.display_tariff_name ==
                      "Greenman RLM Dynamisch" && (
                      <TooltipMessage
                        heading="heading"
                        message="important_information"
                        message2="rlm_line2"
                        message3="rlm_line3"
                        message4="rlm_line4"
                        link="https://www.vnbdigital.de/"
                        website="VNB’s_website"
                        src={infoIconPath}
                      />
                    )}
                  </span>
                </li>
              </ul>
            </div>
          </div>

          {[
            "greenman_slp_spot_business_generic_2",
            "greenman_rlm_spot_business_generic",
            "greenman_slp_spot_household_generic",
            "greenman_slp_spot_household_generic_2",
          ].includes(values?.tariff_name) && (
            <div className="mt-1 mt-md-3 medium rounded">
              <p className="fontSize16Regular lineHeight24 text-blue mb-2 mb-md-4">
                <strong>GME Dynamic:</strong> {t("offer_bottom")}
              </p>

              {/* <p className="m-0 text-blue fontSize16Regular lineHeight24">
                Calculation is based on the price at {date} and {time} compared
                to y all text is placeholder
              </p> */}
            </div>
          )}

          {/* uncommenting this as there in Figma */}
          <p className="mt-2 mb-0 mt-md-4 fontSize16Regular lineHeight24 text-blue">
            {values?.isBusiness ? t("Prices exclude") : t("Prices include")}{" "}
            {values?.vat_rate}% {t("VAT")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default OfferCard;
